import React from 'react';
import styled from 'styled-components';
import IconChevronDownCircleOutline from './IconChevronDownCircleOutline';
var IconChevronRightCircleOutline = /*#__PURE__*/styled(IconChevronDownCircleOutline).withConfig({
  displayName: "IconChevronRightCircleOutline",
  componentId: "c11n-8-64-0__sc-1mu1qof-0"
})(["transform:rotate(270deg);"]);
IconChevronRightCircleOutline.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Chevron Right")
};
export default IconChevronRightCircleOutline;